import React, { useState } from 'react'
import Header from "../components/global/Header"
import Footer from "../components/global/Footer"
import Item from "../assets/images/gentamycin1.png"
import StoreData from "../components/stores/StoreData"
import { Link } from "react-router-dom"


function DrugDetails() {
  const [itemsNo, setItemsNo] = useState(0)
  const AddItemsNo = () => {
    setItemsNo((prev) => prev + 1)
  }
  const SubtractItemsNo = () => {
    if (itemsNo > 0) {
      setItemsNo((prev) => prev - 1)
    }
  }
  const Total = () => {
    return (itemsNo * 1570)
  }
  return (
    <div>
      <Header />
      <div className="container">
        <div className="itemdetails row">
          <div className="col-md-6 ">
            <div className="itemimage">
              <img className="itemimage__1" src={Item} alt="" srcset="" /><br />

            </div>
            <div className="itemimage__sub" >
              <div style={{ padding: '0 20px' }}><img className="itemimage__2" src={Item} alt="" srcset="" /></div>
              <div><img className="itemimage__3" src={Item} alt="" srcset="" /></div>
              <div style={{ padding: '0 20px' }}><img className="itemimage__4" src={Item} alt="" srcset="" /></div>

            </div>


          </div>
          <div className=" col-md-4 iteminfo">
            <div className="col-12">
              <p className="store__items__description__title">Gentamyclin</p>
              <p>Tablet 50 pieces</p>
              <p>Drug description from the pharmacy below</p>

              <div className="itemdetails__number">
                <button
                  onClick={() => SubtractItemsNo()}
                  className="itemdetails__number__control"
                >
                  -
              </button>

                <input
                  type="text"
                  className="itemdetails__number__count"
                  value={itemsNo}
                />


                <button
                  onClick={() => AddItemsNo()}
                  className="itemdetails__number__control"
                >
                  +
              </button>

              </div>
              <span className="itemdetails__price"> ₦{Total()}</span><br />
              <button className="AddCart">Add to Cart</button>
              <p className="itemdetails__title">Specifications</p>
              <p className="itemdetails__subtitle">Dosage form</p>
              <p className="itemdetails__text">Pills</p>
              <p className="itemdetails__subtitle">Dosage </p>
              <p className="itemdetails__text">0.25g</p>
              <p className="itemdetails__subtitle">Active Substance</p>
              <p className="itemdetails__text">Gentamycin</p>
              <p className="itemdetails__subtitle">Pharmacy Store</p>
              <p className="itemdetails__text">Bicycle Pharmacy</p><br />
              <Link to="/store-detail">View Store Detail</Link>
            </div>

          </div>
        </div>
        <div className="products">
          <p className="products__title">SIMILAR PRODUCTS</p>
          <p className="products__subtitle">Similar Products from our Inventory</p>

        </div>

      </div>
      <StoreData />
      <Footer />
    </div>
  )
}

export default DrugDetails;